import React from 'react'
import './Works.css'

const groups = [
  ['Frontend', ['JavaScript','TypeScript','React','Next.js','HTML5','CSS3','Tailwind CSS','Bootstrap']],
  ['Backend', ['Node.js','Express.js','NestJS','PHP','REST APIs','JWT Authentication','Socket.IO']],
  ['Databases', ['PostgreSQL','MySQL','MongoDB','Prisma ORM','SQL','Database Design']],
  ['DevOps & Infrastructure', ['Git','GitHub','Linux','Nginx','PM2','CI/CD','GitHub Actions','Server Administration']],
  ['Additional', ['Flutter','React Native','Power BI','Tableau','Network Administration','Cybersecurity Fundamentals']]
]

const Works = () => (
  <section className='works site-shell' id='Skills'>
    <div className='section-header'><span className='section-eyebrow'>Technical skills</span><h2 className='section-title'>A practical stack for complete product delivery</h2><p className='section-copy'>From user interfaces and business logic to databases, authentication, deployment, and operational support.</p></div>
    <div className='stack-grid'>{groups.map(([title, items]) => <article className='stack-card' key={title}><h3>{title}</h3><div>{items.map(item => <span key={item}>{item}</span>)}</div></article>)}</div>
  </section>
)
export default Works
